
import React from 'react';
import { Brain, Cpu, Database } from 'lucide-react';

const StackColumn = ({ icon: Icon, title, description, items }: { icon: any, title: string, description: string, items: { category: string, tools: string }[] }) => (
  <div className="p-8 rounded-2xl border border-slate-800 bg-slate-900/20 hover:bg-slate-900/40 transition-colors">
    <div className="w-12 h-12 rounded-lg bg-emerald-500/10 flex items-center justify-center text-emerald-400 mb-6">
      <Icon size={24} />
    </div>
    <h4 className="text-xl font-bold text-white mb-2">{title}</h4>
    <p className="text-slate-500 text-sm mb-8">{description}</p>
    
    <div className="space-y-6">
      {items.map((item, idx) => (
        <div key={idx}>
          <div className="text-xs font-mono text-emerald-500/80 uppercase tracking-widest mb-1">{item.category}</div>
          <div className="text-slate-300 font-medium leading-relaxed">{item.tools}</div>
        </div>
      ))}
    </div>
  </div>
);

const Stack: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-6">
      <div className="mb-16">
        <h2 className="text-xs font-mono text-emerald-500 uppercase tracking-[0.2em] mb-4">Expertise</h2>
        <h3 className="text-4xl md:text-5xl font-bold text-white mb-6">The GTM Stack.</h3>
        <p className="text-slate-400 max-w-2xl text-lg">
          I don't just use tools; I connect them. Here is the infrastructure I build with.
        </p>
      </div>
      
      <div className="grid md:grid-cols-3 gap-8">
        <StackColumn 
          icon={Brain}
          title="Intelligence & Data"
          description="The 'Brain' of the operation."
          items={[
            { category: "Languages", tools: "Python, SQL, JavaScript" },
            { category: "AI", tools: "OpenAI API, Anthropic, LLM Fine-tuning" },
            { category: "Data", tools: "Web Scraping, Clay, Apollo, Clearbit" }
          ]}
        />
        <StackColumn 
          icon={Cpu}
          title="Orchestration"
          description="The 'Glue' that holds it together."
          items={[
            { category: "Middleware", tools: "n8n (Advanced), Make.com, Zapier" },
            { category: "APIs", tools: "REST API Integration, Webhooks" },
            { category: "Logic", tools: "JSON Data Transformation, Regex" }
          ]}
        />
        <StackColumn 
          icon={Database}
          title="Revenue Platforms"
          description="The 'Database' where value lives."
          items={[
            { category: "CRM", tools: "Salesforce, HubSpot" },
            { category: "Outbound", tools: "Instantly, Smartlead, Lemlist" },
            { category: "Engagement", tools: "WhatsApp Business API, Twilio, MailerLite" }
          ]}
        />
      </div>
    </div>
  );
};

export default Stack;
